import { clearObject } from "@/modules/utils";
import { useApiWithAuth } from "@/modules/api";
import { PermissionPayload } from "@/modules/auth";
import { ClientePayload } from "@/modules/business/cliente/clienteBusiness";

interface TabelaPrecoFilterPayload {
  idCliente?: number | null;
  idOrgao?: number | null;
  tipoSolicitacao?: number | null;
  ativo?: boolean | null;
}

interface TabelaPrecoPayload {
  idTabelaPreco?: number | null;
  idOrgao?: number | null;
  tipoSolicitacao?: number | null;
  tipoVeiculo?: string | null;
  preco?: number | null;
  flAtivo?: boolean | null;
  cliente?: ClientePayload | null;
  permissionInfo?: PermissionPayload;
}

const useTabelaPrecoService = () => {
  const { data, loading, get, post, put, patch } = useApiWithAuth();

  const searchTabelasPreco = (
    filter: TabelaPrecoFilterPayload,
    page: number
  ): Promise<void> => {
    return get("/tabela-preco", {
      ...clearObject(filter),
      ...{
        page: page
      }
    });
  };

  const getTabelaPreco = (idTabelaPreco: number): Promise<void> => {
    return get(`/tabela-preco/${idTabelaPreco}`);
  };

  const saveNewTabelaPreco = (entity: TabelaPrecoPayload): Promise<void> => {
    return post("/tabela-preco", entity);
  };

  const updateTabelaPreco = (
    idTabelaPreco: number,
    entity: TabelaPrecoPayload
  ): Promise<void> => {
    return put(`/tabela-preco/${idTabelaPreco}`, entity);
  };

  const shelveTabelaPreco = (idTabelaPreco: number): Promise<void> => {
    return patch(`/tabela-preco/${idTabelaPreco}/arquivar`);
  };

  const safeTabelaPreco = (
    entity?: TabelaPrecoPayload | null
  ): TabelaPrecoPayload => {
    return entity ?? { flAtivo: true };
  };

  const safeFilterTabelaPreco = (): TabelaPrecoFilterPayload => {
    return {};
  };

  return {
    data,
    loading,
    searchTabelasPreco,
    getTabelaPreco,
    saveNewTabelaPreco,
    updateTabelaPreco,
    shelveTabelaPreco,
    safeTabelaPreco,
    safeFilterTabelaPreco
  };
};

export { useTabelaPrecoService, TabelaPrecoPayload, TabelaPrecoFilterPayload };
